import React from "react";
import styles from "./styles.module.scss";
import LazyAssets from "@/app/utils/assets_widget";
import {TextBold14, TextMedium12, TextMedium14, ThirtyText} from "@/app/components/texts";
import {CourtBigModel} from "@/app/api/courts";
import Button from "@/app/components/button";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import {ReviewModel} from "@/app/api/reviews";
import UserAvatar from "@/app/components/user_avatar/widget";
import {getDaysAgo} from "@/app/utils/custom_function";
import Chip from "@/app/components/chip";
import classNames from "classnames";
import {openUrlSafely} from "@/app/utils/url_helper";
import {SmartImage} from "@/app/components/smart_image/widget";
import { logEventSafe } from "@/app/utils/analytics";

interface Props {
  data?: CourtBigModel;
  reviews?: ReviewModel[];
  goToCreateMatch: (court: CourtBigModel | undefined, review: ReviewModel[] | undefined) => void
  courtOnMatch?: boolean
  onApprove?: () => void
  onReject?: () => void
}

const CourtInfoWidget: React.FC<Props> = ({data, reviews, goToCreateMatch, courtOnMatch, onApprove, onReject}) => (
  <>
    {data === undefined && <div>no data</div>}
    <div className={classNames(styles.header, {[styles.courtOnMatch]: courtOnMatch})}>
      <SmartImage
      className={styles.image}
      alt={data?.name}
      sources={[
        data?.imagesUrls?.[0] ?? "",
        "https://app.padelmatchapp.com/static/media/auth_first.ba3208e7edc85629cc09.png",
        "https://www.ltapadel.org.uk/4961c8/globalassets/information-articles/indoor-padel-court.jpg?w=1200",
      ]}
    />
      {data?.websiteLink === null ? null : (
        <button
          className={styles.shareBtn}
          onClick={() => {
            if (data?.websiteLink) {
              logEventSafe('padel_court_booking_start', {
                club_id: data?.id,
                court_id: data?.id,
              });
              openUrlSafely(data.websiteLink);
            }
          }}
        >
          <LazyAssets.ShareNormal />
        </button>
      )}
    </div>
    <div className={styles.content}>
      <div className={styles.titleAndSubtitle}>
        <ThirtyText text={data?.name} className={styles.title}/>
        <TextBold14 text={data?.address} className={styles.subtitle}/>
      </div>
      <div className={styles.infoRow}>
        <div className={styles.iconText}>
          <LazyAssets.GolfHole/> <TextMedium14
          text={((data?.numberOfCourts ?? 1) === 8 ? "8+" : data?.numberOfCourts ?? 1).toString()}/>
        </div>
        <div className={styles.iconText}>
          <LazyAssets.Star className={styles.star}/> <TextMedium14 text={(data?.avgRating ?? 0).toString()}/>
        </div>
      </div>
      <div className={styles.chips}>
        {data?.type !== undefined && data?.type.length > 0 && data?.type.map((type) => (<Chip text={type}/>))}
        {/*{data?.describeThisLocation !== undefined && data?.describeThisLocation !== null &&*/}
        {/*    <Chip text={data.describeThisLocation.replaceAll("_", " ")}/>}*/}
        {data?.bookingRequired && <Chip text={t(s.bookingRequired)}/>}
        {data?.lockerRooms && <Chip text={t(s.lockerRooms)}/>}
        {data?.artificialLight && <Chip text={t(s.artificialLight)}/>}
        {data?.parkingAvailability && <Chip text={t(s.parkingAvailability)}/>}
        {data?.socialVibe && <Chip text={t(s.socialVibe)}/>}
        {data?.coachAvailable && <Chip text={t(s.coachAvailable)}/>}
        {data?.hasCafeOrBar && <Chip text={t(s.cafeBar)}/>}
        {data?.rentalGearAvailable && <Chip text={t(s.rentalGear)}/>}
      </div>
      <TextMedium14 text={data?.description} className={styles.description}/>
      {!courtOnMatch && <Button text={t(s.createAMatch)} onClick={() => goToCreateMatch(data, reviews)}/>}
      {onApprove && onReject && <div className={styles.buttons}>
          <Button text={t(s.approve)} onClick={onApprove}/>
          <Button text={t(s.reject)} onClick={onReject} isRed/>
      </div>}
      {(reviews?.length ?? 0) > 0 && <div className={styles.reviews}>
          <ThirtyText text={t(s.reviews)}/>
        {reviews?.map((review, index) => (
          <div key={index} className={styles.review}>
            <div className={styles.author}>
              <div className={styles.avatar}>
                <UserAvatar userAvatar={review.authorImageUrl} userName={review.authorUsername}/>
              </div>
              <TextMedium14 text={review.authorUsername}/>
            </div>
            <div className={styles.starAndDate}>
              <div className={styles.assessment}>
                {Array.from({length: review.rating}, (_, index) => (
                  <LazyAssets.Star key={index} className={styles.star}/>
                ))}
                {Array.from({length: 5 - review.rating}, (_, index) => (
                  <LazyAssets.StarEmpty key={index} className={styles.star}/>
                ))}
                <TextMedium14 text={review.rating.toString()}/>
              </div>
              <TextMedium12 text={getDaysAgo(review.createdAt)} className={styles.date}/>
            </div>
            <TextMedium14 text={review.comment} className={styles.text}/>
          </div>))}
      </div>}
    </div>
  </>
);

export default CourtInfoWidget;